import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import { ConnectedRouter } from 'connected-react-router';
import * as enLocale from 'react-intl/locale-data/en';
import * as deLocale from 'react-intl/locale-data/de';

import { LOCALE } from 'src/constants/locale';
import { HISTORY } from 'src/constants/history';
import { I18N_LOCALES } from 'src/constants/i18nLocales';
import { I18N_MESSAGES } from 'src/constants/i18nMessages';
import { SearchPage } from 'src/components/SearchPage';
import { initStore } from 'src/initStore';
import { Route, Switch } from 'react-router-dom';
import { Clients } from '@xiag-search/sdk';

export { sendVisitRecommendationEvent } from './sendVisitRecommendationEvent';
export { getClients } from './getClients';

export async function init(
    root: HTMLElement,
    clients: Promise<Clients>,
    dnt: boolean = true,
): Promise<void> {
    addLocaleData(enLocale);
    addLocaleData(deLocale);
    const clientsResolved  = await clients;
    const store = initStore(clientsResolved, dnt);
    const i18nLocale = I18N_LOCALES[LOCALE];
    const i18nMessages = I18N_MESSAGES[LOCALE];
    render((
        <Provider store={store}>
            <IntlProvider locale={i18nLocale} messages={i18nMessages}>
                <ConnectedRouter history={HISTORY}>
                    <Switch>
                    <Route exact={true} path="(/de/suche|/en/search)">
                    <SearchPage/>
                    </Route>
                    </Switch>
                </ConnectedRouter>
            </IntlProvider>
        </Provider>
    ), root);
}
